import { createActionCreator, createReducer } from "deox";
import { produce } from "immer";
import { Dispatch } from "redux";
import * as wishService from "../services/wish";
import { ApplicationState } from "./store";
import { isArray } from "lodash";

export type WishItem = {
  id: number;
  productId: number;
  product: any;
};

export type State = {
  data: WishItem[] | null;
};

const fetchWishItems = Object.assign(
  () => async (dispatch: Dispatch) => {
    try {
      const data = await wishService.getWishItems();
      dispatch(fetchWishItems.success(data));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator(
      "@@WISH/FETCH/SUCCESS",
      resolve => (items: WishItem[]) => resolve(items)
    ),
  }
);

const addToWish = Object.assign(
  (productId: number) => async (dispatch: Dispatch) => {
    try {
      await wishService.addWishItem(productId);

      const refreshed = await wishService.getWishItems();
      dispatch(fetchWishItems.success(refreshed));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator(
      "@@WISH/ADD/SUCCESS",
      resolve => (item: WishItem) => resolve(item)
    ),
  }
);

const removeFromWish = Object.assign(
  (productId: number) => async (dispatch: Dispatch) => {
    try {
      await wishService.removeWishItem(productId);
      dispatch(removeFromWish.success(productId));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator(
      "@@WISH/REMOVE/SUCCESS",
      resolve => (productId: number) => resolve(productId)
    ),
  }
);

const defaultState: State = {
  data: null,
};

const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchWishItems.success, (state, action) =>
    produce(state, draft => {
      draft.data = action.payload;
    })
  ),

  handleAction(removeFromWish.success, (state, action) =>
    produce(state, draft => {
      draft.data = (draft.data || []).filter(
        w => w.productId !== action.payload
      );
    })
  ),
]);

export const actions = {
  fetchWishItems,
  addToWish,
  removeFromWish,
};

export { reducer };
